import React, { useEffect } from "react";
import LogoLayout from "../../components/logolayout/logolayout";
import TextInput from "../../components/form/inputs/text-input/text-input";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../config/axios";
import { showToast } from "../../utils/utils";
import { useAppContext } from "../../context/app.context";

export default function LoginPage() {
  const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const { setAppInfos } = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    (window as any)?.ReactNativeWebView?.postMessage("close");
  }, []);

  async function onSubmit(form: any) {
    try {
      const { data } = await axiosInstance.post("login", form);
      const { user, plans } = data;
      const { role, status } = user;

      if (role === "Cavalier" || role === "Propriétaire") {
        return showToast("Téléchargez l’appli…");
      }

      setAppInfos({ token: data.token, user });

      if (status === "ACTIVE") {
        navigate(role === "Structure" ? "/structure" : "/prestataire/profil");
      } else if (status === "WAITING_FOR_PAYMENT") {
        navigate("/register/subscription", {
          state: {
            plans,
            form: user,
          },
        });
      } else if (status === "PENDING_REGISTER") {
        showToast(
          "Les informations de connexion sont incorrectes. Veuillez réessayer ou vous créer un compte."
        );
      }
    } catch (e) {
      showToast("Les informations de connexion sont incorrectes");
    }
  }

  const today = new Date();
  const eighteenYearsAgo = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
  );
  return (
    <LogoLayout
      renderAfterSubmit={() => (
        <div className="bottomlink">
          <span className="currentR">Pas encore de compte ?</span>
          <Link className="btn-tertiary" title="login" to="/register">
            <span>S’inscrire</span>
          </Link>
        </div>
      )}
      submitTitle="Se connecter"
      onSubmit={onSubmit}
      hideBack={true}
    >
      <h1>Bienvenue !</h1>
      <h2 className="title">Se connecter</h2>
      <div>
        <TextInput
          validate={(val: any) =>
            !emailReg.test(val) ? "Adresse e-mail invalide" : true
          }
          name="email"
          autocomplete="off"
          type="email"
          placeHolder="Votre email"
          label="Adresse e-mail"
        />
        <TextInput
          className="flex-row"
          autocomplete="off"
          showPassword
          name="password"
          type="password"
          required="Mot de passe invalide"
          placeHolder="Votre mot de passe"
          label="Mot de passe"
        />
        <div className="loginlink">
          <span className="currentR">Mot de passe oublié ?</span>
          <Link className="btn-tertiary" title="login" to="/password/reset">
            <span>Cliquez ici</span>
          </Link>
        </div>
      </div>
    </LogoLayout>
  );
}
